import $ from 'jquery';

export default function MainController($http, $scope) {
  const vm = this;

  vm.formActive = null;
  vm.open = (id) => {
    $('#modalcontato').modal('show');
    vm.formActive = id;
    vm.isSuccess = false;
  };

  window.openModal = function (id) {
    vm.open(id);
  };

  $scope.$watch('main.formActive', () => (vm.errors = null));

  vm.isSuccess = false;
  vm.isSubmiting = false;

  vm.send = (form) => {
    vm.errors = null;

    // Valida o formulário
    if (form.$invalid) {
      // Ativa os erros nos inputs formulário
      vm.isError = true;
      form.$dirty = true;
      form.$$controls.forEach((element, idx) => {
        form.$$controls[idx].$dirty = true;
      });

      return;
    }

    vm.isSubmiting = true;

    const request = {
      name: form.name.$modelValue,
      phone: form.phone.$modelValue,
      type: vm.formActive,
      email: form.email.$modelValue,
      message: form.message.$modelValue,
      website: 'setpar.com.br',
    };

    const urlPost = '/set-json/v1/contato';
    const errorDefault =
      'Um erro inesperado o ocorreu, tente novamente mais tarde';

    vm.isSubmiting = true; // exibe o loading
    vm.isError = false;

    $http({
      url: urlPost,
      method: 'POST',
      data: request,
    })
      .then((response) => {
        vm.isSubmiting = false; // Esconde o loading
        if (response.status === 200) {
          vm.isSuccess = true; // Exibe msg de sucesso
          $('form[name=contactForm]')[0].reset(); // Limpa o formulário
          form.$setPristine();
        } else if (response.data && response.data.error) {
          vm.errors = response.data.error;
        } else {
          vm.errors = errorDefault; // exibe msg de erro padrão
        }
      })
      .catch((error) => {
        vm.isSubmiting = false; // esconde o loading
        vm.errors = errorDefault; // exibe msg de error padrão
        console.error(error);
      });
  };
}
